/**
 * Script to load Gotham & Font Awesome fonts for use in Coordinator App.
 */

// Font-Awesome fonts
require("./styles/font-awesome-fonts.scss");

// Gotham fonts
require("./styles/gotham-fonts.scss");

// Quadon fonts
require("./styles/quadon-fonts.scss");



/** WEBPACK FOOTER **
 ** ./src/fonts.js
 **/